import * as React from "react";
import { Link, styled } from "@mui/material";
import { ClinicSmallLink } from "../elements/ClinicSmallLink";

//region [[ Styles ]]

const SignLinksView = styled("div")({
  textAlign: "center",
  fontSize: 14,
  marginTop: 24,
});

//endregion [[ Styles ]]

//region [[ Props ]]

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SignInLink = (props: { goToSignIn: () => void }) => {
  return (
    <SignLinksView>
      Already have an account?&nbsp;
      <ClinicSmallLink onClick={props.goToSignIn}>Sign in</ClinicSmallLink>
    </SignLinksView>
  );
};

export const SignUpLink = (props: { goToSignUp: () => void }) => {
  return (
    <SignLinksView>
      Don't have an account?&nbsp;
      <ClinicSmallLink onClick={props.goToSignUp}>Sign up</ClinicSmallLink>
    </SignLinksView>
  );
};
